<template>
  <div class="static-top-bar-foodleap" :class="{'static-top-bar-isFoodleap': isCNZ }">
    <div class="static-top-bar-foodleap__content">
      <div v-if="$store.getters.isEcAerospace">
        <h1 style="color: white;">{{ title }}</h1>
      </div>
      <div v-else-if="$store.getters.isEcHealth" style="width: 130px;">
        <img src="/images/static-home-page/ec-health/canterbury-health-innovation-image.png" :alt="title"/>
      </div>

      <div class="static-top-bar-foodleap__navigation">
        <ul>
          <router-link
            to="/dashboards/home"
            target="_self"
            class="navigation_item"
          >
            <li>Home</li>
          </router-link>
          <router-link
            to="/register"
            target="_self"
            class="navigation_item"
          >
            <li>Register</li>
          </router-link>
          <a
            href="mailto:platforms@christchurchnz.com"
            target="_blank"
            class="navigation_item"
          >
            <li>Contact</li>
          </a>

        </ul>
      </div>
      <div class="static-top-bar-foodleap__buttons" style="align-content: center; flex-wrap: wrap;">
        <div style="height: 40px; display: flex; flex-direction: row;">
          <ds-button
            class="login_button"
            variant="primary"
            label="Register"
            :style="registerButtonStyle"
            :size="null"
            @click="openSignupModal"
          />
          <ds-button
            class="login_button"
            variant="primary"
            label="Login"
            :style="loginButtonStyle"
            :size="null"
            @click="openSigninModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui.js'
  import MODAL_IDS from '../../constants/modal-ids.js'
  import { trackHeapEvent } from '../../util/analytics.js'
  import NavigationItem from '../Navigation/NavigationItem.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {},
    data () {
      return {}
    },
    methods: {
      openSigninModal () {
        trackHeapEvent('staticHomePage.topBarLogin')

        this.$router.push('/login')
      },
      openSignupModal () {
        trackHeapEvent('staticHomePage.topBarRegister')

        if (this.$store.getters.hasAccessToEcosystemMemberPackages) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.PACKAGES_SIGN_UP)
        } else {
          this.$router.push('/register')
        }
      },
    },
    computed: {
      title () {
        if (this.$store.getters.isEcAerospace) {
          return 'Aerospace Navigator powered by ChristchurchNZ'
        } else if (this.$store.getters.isEcHealth) {
          return 'Canterbury Health Innovation powered by ChristchurchNZ'
        }
      },
      leftLogoUrl () {
        return this.config.logo_url_light || this.config.logo_url
      },
      isCNZ () {
        return this.$store.getters.isCNZEcosystem
      },
      registerButtonStyle () {
        return {
          backgroundColor: '#ED1C24',
          fontWeight: '',
          color: 'white',
          height: 'auto',
          width: '90px',
          border: '2px solid white',
          borderRadius: '4px',
          textTransform: 'capitalize',
        }
      },
      loginButtonStyle () {
        return {
          backgroundColor: '#231F20',
          fontFamily: '',
          fontWeight: '',
          color: 'white',
          height: 'auto',
          width: '90px',
          border: '2px solid white',
          borderRadius: '4px',
          textTransform: 'capitalize',

        }
      },
      config () {
        return this.$store.state.config
      },
    },
    mounted () {
    },
    beforeUnmount () {
    },
    mixins: [],
    components: {
      NavigationItem,
    },
  })
</script>

<style scoped lang="scss">
  @import "resources/assets/scss/variables";

  .static-logo-image {
    max-height: 40px;
    height: auto;
    max-width: calc(100vw - 100px - 190px);
    object-fit: contain;
    align-self: center;
  }

  .static-top-bar-foodleap {
    align-content: center;
    padding: 10px 50px 10px 50px;
    background: #231F20;
    font-family: Museo, serif;
    min-height: 80px;

    @media (max-width: $screen-md-max) {
      padding: 10px 0px 0px 0px;
    }

    .static-top-bar-foodleap__navigation {
      display: flex;
      margin-left: auto;
      padding-left: 4%;
      font-family: "DM Sans", sans-serif;

      ul {
        display: flex;
        align-items: center;

        li {
          color: #FFF;
          margin-right: 40px;
          cursor: pointer;
          font-size: 20px;
        }
      }
    }

    .static-top-bar-foodleap__content {
      display: flex;

      .static-top-bar-foodleap__buttons {
        margin-left: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;

        :deep(.button__label) {
          font-family: Museo, serif;
        }
      }
    }

    .navigation_item {
      color: #21244A;
    }

    .navigation__link--active {
      color: white;
    }

    @media(min-width: $screen-sm) {
      .static-top-bar-foodleap__content {
        justify-content: center;
      }
    }
    @media (max-width: $screen-md-max) {
      .static-top-bar-foodleap__content {
        display: flex;
        margin-left: 0;
        align-items: center;

        .static-top-bar-foodleap__buttons {
          margin-left: 0;
          text-align: right;

          .login_button {
            width: 90px;
          }
        }

        .static-logo-image {
          display: none;
        }
      }
      .static-top-bar-foodleap__navigation {
        margin-left: 0;
        text-align: left;
        padding-left: 0;

        ul {
          flex-direction: column;
          display: flex;
          margin: 20px;

          li {
            margin-bottom: 10px;
            cursor: pointer;
            font-size: 18px;
          }
        }
      }
    }
  }
</style>
